export enum SiteRegion {
    CN = 'CN',
    US = 'US',
    EU = 'EU',
}
